import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { UserInfoService } from "src/app/services/user-info.service";
import { ZpDataService } from "src/app/services/zp-data.service";
import { Router } from "@angular/router";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { FooterVisibilityService } from "src/app/services/footer-visibility.service";
import { browserRefresh } from "../../app.component";
import { ThemeService } from "src/app/theme/theme-service.service";
import { HttpParams } from "@angular/common/http";
import { GetInfoAndPassService } from "src/app/services/get-info-and-pass.service";

@Component({
  selector: "app-payment-choose-plan",
  templateUrl: "./payment-choose-plan.component.html",
  styleUrls: ["./payment-choose-plan.component.scss"],
  standalone: false,
})
export class PaymentChoosePlanComponent implements OnInit {
  public toggleDiscoundCode: boolean = false;
  public browserRefresh: boolean;
  public chosenPlan;
  public planPaymentType;
  public chosenPaymentType;
  public id;
  public myUser;
  public Subscription: Subscription;
  public submitted = false;
  public paymentFee;
  public paymentPeriod;
  public myPlanHolder: any;
  public user;
  public refCode: any;
  public getCbPlan;
  public price: any;
  // Form Payment Type
  public choosePlanFormGroup: UntypedFormGroup = new UntypedFormGroup({
    planPaymentType: new UntypedFormControl("perYear"),
    hasDiscountCode: new UntypedFormControl(false),
    selectOrganization: new UntypedFormControl(""),
    discountCode: new UntypedFormControl(""),
  });
  public userPlan: any;
  public responseFromLogin: any;
  public exportDataValue: any;
  public showExportDataBtn: boolean = false;

  constructor(
    private userInfoService: UserInfoService,
    private zenplansDataService: ZpDataService,
    private router: Router,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private footerVisibilityService: FooterVisibilityService,
    public themeService: ThemeService,
    private getInfoAndPassService: GetInfoAndPassService
  ) {}

  async ngOnInit() {
    this.zenplansDataService.getUser().then(async (user) => {
      this.user = user;
      this.refCode = user.refCode;
      await this.zenplansDataService.setRefCode(this.refCode);
      this.getCbPlan =
        await this.zenplansDataService.getDynamicPricingFromChargeBee(
          user.refCode
        );
      if (this.getCbPlan) {
        this.price = this.getCbPlan.price;
        this.chosenPlan =
          this.getCbPlan.period !== "year" ? "perMonth" : "perYear";
      }
      this.userPlan = await this.zenplansDataService.retrieveData(
        // retrieve the plan
        "get",
        "/api/plan",
        new HttpParams().set("clientId", this.user.Id)
      );
      console.log("this.userPlan", this.userPlan);
    });

    const data = sessionStorage.getItem("zp_data_for_export");
    this.exportDataValue = data ? JSON.parse(data) : null;
    console.log("value", this.exportDataValue);
    this.showExportDataBtn = !!this.exportDataValue?.planExists;

    this.sideNavBarVisibilityService.hideSideNav = true;
    this.footerVisibilityService.hideFooter = true;
    this.Subscription = this.userInfoService.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
    });
    await this.getMyUser();

    // Form Payment Type
    this.choosePlanFormGroup.addControl(
      "planPaymentType",
      new UntypedFormControl(this.myUser.planPaymentType)
    );
  }

  async getMyUser() {
    if (!this.myUser) {
      await this.zenplansDataService.getUser();
    }
  }

  setPaymentType(chosenPaymentType) {
    this.chosenPlan = chosenPaymentType;
    this.planPaymentType = chosenPaymentType;
  }

  async onSubmit() {
    this.submitted = true;
    if (this.choosePlanFormGroup.invalid) {
      return;
    }
    var chargebeeInstance = window["Chargebee"].init({
      site: this.zenplansDataService.chargeBeeSite,
    });
    var self = this;
    chargebeeInstance.openCheckout({
      hostedPage: function () {
        return self.zenplansDataService.chargeBeeCheckout({
          plan: "zenplans-annual",
        });
      },
      success: async function (hostedPageId) {
        console.log("hostedPageId", hostedPageId);
        // success callback
        let res = await self.zenplansDataService.chargeBeeSaveSubscriptionId(
          hostedPageId
        );
        console.log("res", res);
        let myPlanHolder = await self.zenplansDataService.getUser();
        if (res.success) {
          if (myPlanHolder.userType == "planHolder") {
            self.router.navigate(["/security-page-sign-up"]);
          } else {
            self.router.navigate(["/home"]);
          }
        } else {
          alert("Something failed when saving the subscription information.");
        }
      },
      error: function () {
        alert(
          "Sorry, an error occurred, please log-in and try again, or contact support."
        );
        self.zenplansDataService.logout();
        self.router.navigate(["/log-in"]);
      },
    });
  }

  async exportData() {
    await this.zenplansDataService.getUserDataToExport();
  }

  ngOnDestroy() {
    this.sideNavBarVisibilityService.hideSideNav = false;
    this.footerVisibilityService.hideFooter = false;
  }
}
